var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"skeleton",class:{ paused: _vm.paused, scale: _vm.scale },style:({ height: _vm.height, width: _vm.width })})
}
var staticRenderFns = []

export { render, staticRenderFns }